import { Background, ReactFlow, type ReactFlowProps } from '@xyflow/react';
import type { ReactNode } from 'react';
import '@xyflow/react/dist/style.css';
import { Controls } from './controls';

type CanvasProps = ReactFlowProps & {
  children?: ReactNode;
  /**
   * Extra buttons appended to the zoom-controls cluster (React Flow renders them
   * after the default zoom/fit/lock buttons). Pass `ControlButton`s here to add
   * canvas utilities — e.g. undo/redo — to the bottom-left bar rather than a
   * separate floating panel. Omitted → just the default controls.
   */
  controlsSlot?: ReactNode;
};

export const Canvas = ({ children, controlsSlot, ...props }: CanvasProps) => (
  <ReactFlow
    deleteKeyCode={['Backspace', 'Delete']}
    fitView
    panOnDrag={false}
    panOnScroll
    selectionOnDrag={true}
    zoomOnDoubleClick={false}
    {...props}
  >
    <Background bgColor="var(--sidebar)" />
    <Controls>{controlsSlot}</Controls>
    {children}
  </ReactFlow>
);
